import { useQuery } from '@tanstack/react-query';
import { v1 } from '@/api/client';
import type { RmsReportDto } from './api.types';
import { rmsReportDtoSchema } from './api-schema';
import { transformReports } from './transform';

export const useReportsQuery = () =>
  useQuery({
    queryKey: ['rms', 'reports'],
    queryFn: () =>
      v1.get<RmsReportDto[]>('rms/reports?size=200', {
        schema: rmsReportDtoSchema,
      }),
    select: transformReports,
  });
